"use client";

/**
 * The "Download the skill" link on a System Card edition. A client leaf so
 * the edition page, a prerendered server component, can count downloads
 * (`learn_system_card_skill_downloaded`) without becoming a client boundary.
 */
import { trackLearnSystemCardSkillDownloaded } from "@/lib/analytics/client";

export interface SystemCardSkillDownloadProps {
  href: string;
  filename: string;
  slug: string;
  className: string;
  label: string;
}

export function SystemCardSkillDownload({ href, filename, slug, className, label }: SystemCardSkillDownloadProps) {
  return (
    <a href={href} download={filename} onClick={() => trackLearnSystemCardSkillDownloaded({ slug })} className={className}>
      {label}
    </a>
  );
}
